import React, {useState, useEffect} from "react";
import Search from "../Search";
import {Link} from "react-router-dom";
import {Link as ScrollLink} from "react-scroll";

function GetStartedSideMenu({menu}) {
  useEffect(() => {
    const apiDetails = document.querySelectorAll(".api-detail");
    const methods = document.querySelectorAll(".method-name");
    const sideMenuMethods = document.querySelectorAll(".side-menu-methods");

    // Intersection observer for API details to open the corresponding menu
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = entry.target?.getAttribute("data-index");
            sideMenuMethods.forEach((method) => {
              method?.classList.remove("active");
            });
            const element = document.getElementById(
              `${entry.target.id + "sidemenu"}`,
            );
            element?.classList.add("active");
          }
        });
      },
      {threshold: 0.7},
    );

    // Intersection observer for method names to highlight in the side menu

    // Observing method names to highlight in the side menu
    // Observing API details to open the corresponding menu
    apiDetails.forEach((apiDetail) => {
      observer.observe(apiDetail);
    });

    // Cleanup function to unobserve elements when the component unmounts
    return () => {
      apiDetails.forEach((apiDetail) => {
        observer.unobserve(apiDetail);
      });
    };
  }, []);


  return (
    <div className="side-wrapper side-menu-layout">
      <div className="side-wrapper-body">
        <div className="search">
          <Search data={menu} />
        </div>
        {menu.map(({header, subEntities}, menuIndex) => {
          return (
            <nav key={`menu-${menuIndex}`}>
              <ul id="toc" className="toc-list-h1">
                <li className="resource-group">
                  <div className="heading">
                    <Link className="toc-h1 toc-link entity-name">
                      {header}
                    </Link>
                    <ul className="toc-list-h1">
                      {subEntities&&subEntities.map(({name, tags}, index) => {
                        return (
                          <li key={`subEntity-${index}`}>
                            <Link
                              className="toc-h1 toc-link side-menu-methods"
                              id={`${name + "sidemenu"}`}
                            >
                              <ScrollLink
                                activeClass="none"
                                to={`${name}`}
                                spy={true}
                                smooth={true}
                                offset={-150}
                                duration={0}
                              >
                                {name}
                              </ScrollLink>
                            </Link>
                            <div>
                              {tags&&tags.map(({name, paths}, index) => {
                                return (
                                  <div key={`tags-${index}`}>
                                    {tags.length > 1 ? (
                                      <>
                                        <Link
                                          className="toc-h2 toc-link"

                                        >
                                          {name}
                                        </Link>
                                      </>
                                    ) : (
                                      <>
                                        {paths&&paths.map((each) => {
                                          return (
                                            <>
                                              <li key={`paths-${index}`}>
                                                <Link
                                                  className="toc-h2 toc-link side-menu-methods"
                                                  id={`${each&&each.method&&each.method.name + "sidemenu"}`}
                                                >
                                                  <span className="sidebar-link-text">
                                                    <ScrollLink
                                                      activeClass="none"
                                                      to={`${each&&each.method&&each.method.name}`}
                                                      spy={true}
                                                      smooth={true}
                                                      offset={-150}
                                                      duration={0}
                                                    >
                                                      {each&&each.method&&each.method.name}
                                                    </ScrollLink>
                                                  </span>

                                                </Link>
                                              </li>
                                            </>
                                          );
                                        })}
                                      </>
                                    )}
                                  </div>
                                );
                              })}
                            </div>

                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </li>
              </ul>
            </nav>
          );
        })}
      </div>
    </div>
  );
}


export default GetStartedSideMenu;
